import { createFileRoute, redirect } from '@tanstack/react-router'
import DetailsLegacyIframe from '@navigator/detail/legacyEmbedded/DetailsLegacyIframe'

export const Route = createFileRoute('/_auth/entity/$entityId/_breadcrumbs/calculationLog')({
  component: RouteComponent,
  beforeLoad: ({ context: { scopedEnablements, scope } }) => {
    if (
      !scopedEnablements.for(scope).hasQualifiedEnablement('EntityModel', 'READ', 'CalculationLog')
    ) {
      throw redirect({
        from: Route.fullPath,
        to: '..',
        replace: true,
      })
    }
  },
})

function RouteComponent() {
  const { entityId } = Route.useParams()
  return <DetailsLegacyIframe src={`entities/calculationlog|entity=${entityId}`} />
}
